export const getEvenPx = val => {
  let res = 0;
  if (val) {
    res = Math.floor(val);
    res = res % 2 === 0 ? res : res + 1;
  }
  return res;
};
